import apiClient from "./apiClient";

export type TaxOption = {
  _id: string;
  name: string;
  rate: number;
  isDefault?: boolean;
};

const normalizeTaxes = (raw: any): TaxOption[] => {
  const items = Array.isArray(raw) ? raw : raw?.taxes;
  if (!Array.isArray(items)) return [];
  return items
    .map((tax: any) => ({
      _id: String(tax?._id?.$oid ?? tax?._id ?? ""),
      name: String(tax?.name ?? ""),
      rate: Number(tax?.rate ?? 0),
      isDefault: tax?.isDefault ?? tax?.default ?? tax?.is_default ?? undefined,
    }))
    .filter((tax) => tax._id && tax.name);
};

export const getUserTaxes = async (): Promise<TaxOption[]> => {
  const { data } = await apiClient.get("/settings/taxes");
  return normalizeTaxes(data);
};

export const getOwnerTaxes = async (): Promise<TaxOption[]> => {
  const { data } = await apiClient.get("/auth/owner-taxes");
  return normalizeTaxes(data);
};
